import { SimpleGrid, Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Heading } from '@feathr/components';

import type { IMetaConnectionData } from '../MetaConnectedView.hooks';
import MetaConnectionDetails from '../MetaConnectionDetails';
import MetaFacebookPagesCard from '../MetaFacebookPagesCard';
import MetaInstagramAccountsCard from '../MetaInstagramAccountsCard';

interface IMetaConnectionOverviewProps {
  connectionData: IMetaConnectionData;
}

function MetaConnectionOverview({
  connectionData: { businessName, connectedOn, facebookPages, instagramAccounts, username },
}: Readonly<IMetaConnectionOverviewProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const hasFacebookPages = facebookPages.length > 0;
  const hasInstagramAccounts = instagramAccounts.length > 0;

  return (
    <Stack gap={theme.spacing[4]}>
      <Heading order={3} variant={'h3'}>
        {t('Connection Overview')}
      </Heading>
      <SimpleGrid cols={3}>
        {hasFacebookPages && <MetaFacebookPagesCard pages={facebookPages} />}
        {hasInstagramAccounts && <MetaInstagramAccountsCard accounts={instagramAccounts} />}
        <MetaConnectionDetails
          businessName={businessName}
          connectedOn={connectedOn}
          username={username}
        />
      </SimpleGrid>
    </Stack>
  );
}

export default MetaConnectionOverview;
